import(/* webpackMode: "eager" */ "/opt/script/frontend/senegaljoogjob/src/app/(auth)/login/login.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/script/frontend/senegaljoogjob/src/components/auth/loginForm/loginForm.jsx");
